import axios from "axios";
import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation,
    fw_progressive_1way,
    inrFormatter,
    make_y_gridlines,
    numberFormat,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    // var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize+20 + "px"
    //var tempVar = chart.tempVar
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)
    console.log("Chart called:", chart)
    console.log("url : ",url);

    axios.post(url, filterParam).then(res => {
        let data = res.data
        console.log("Show data", data);

        //var innerWidth = chart.width - chart.margin.left - chart.margin.right
        //var innerHeight = chart.height - chart.margin.top - chart.margin.bottom

        var groupData = d3.nest().key((d) => {
            return d.dim1_name
        }).entries(data)
        console.log("Group Data :", groupData);

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        var width2 = data.length * chart.vizSpecific2 > chart.width ? chart.width : data.length * chart.vizSpecific2

        var x1AxisLabel = d3.scaleBand().rangeRound([0, width2]).paddingInner(.01)
        var x2AxisLabel = d3.scaleBand()
        var y1AxisLabel = d3.scaleLinear().rangeRound([chart.height, 0])

        //var load = groupData[0].values.map(function(d) { return d.dim2_name; });

        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');

        //Tooltips
        // should there be a class?
        //  d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
        //var y1tip= tooltip_class()

        /* y1tip.attr('class', 'd3-tip'+divId.id)
             .html(d =>
              d.dim2_name + colonAnnotation + numberFormat(d.metric1) + "<br/>" +
              chart.y1MetricTooltip + colonAnnotation + d.dim1_name)
         svg.call(y1tip)*/

        x1AxisLabel.domain(groupData.map(function (d) {
            return d.key;
        }))
        x2AxisLabel.domain(data.map(function (d) {
            return d.dim2_name;
        })).rangeRound([0, x1AxisLabel.bandwidth()])
        y1AxisLabel.domain([0, d3.max(groupData, function (key) {
            return d3.max(key.values, function (d) {
                return d.metric1;
            });
        })]).nice()

        console.log("Dim", data.map(function (d) {
            return d.dim2_name;
        }))

        svg.append('g')
            .attr('class', 'axis-bottom')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1AxisLabel))
            .selectAll("text")
            .style("font-size", axisLabelFontSize )
            .style("text-anchor", "start")
            .attr("dx", XaxisAttribute)
            .attr("dy", "-.55em")
            .attr("transform", "rotate(-90)")
            .text(axisTextDim1);

        /*svg.append("g")
            .attr("class", "y axis")
            .call(d3.axisLeft(y1AxisLabel))
            .style("font-size",axisLabelFontSize)*/

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 115)
            //.style('fill', 'blue')
            .style('fill', '#FF0000')
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(d3.axisLeft(y1AxisLabel).tickFormat(inrFormatter))
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 5)
            .attr('x', 0 - (chart.height / 2) + 140)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', '#FFFF00')
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        if (gridflag == true) {
            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1AxisLabel).tickSize(-chart.width).tickFormat(""))
        }

        var slice = svg.selectAll(".slice")
            .data(groupData)
            .enter().append("g")
            .attr("class", "g")
            .attr('transform', d => 'translate(' + x1AxisLabel(d.key) + ',0)')

        slice.selectAll('rect')
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append('rect')
            .attr('x', d => x2AxisLabel(d.dim2_name))
            .attr('y', y1AxisLabel(0))
            .attr('width', x2AxisLabel.bandwidth())
            .attr('height', chart.height - y1AxisLabel(0))
            .attr('fill', d => metric1ColorScale(d.dim2_name))
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim2_name
                    + "<br/>" + chart.x2MetricTooltip + colonAnnotation + d.dim1_name
                    + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });

        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        slice.selectAll("rect")
            .transition()
            .delay(function () {
                return Math.random() * 1000;
            })
            .duration(1000)
            .attr("y", function (d) {
                return y1AxisLabel(d.metric1);
            })
            .attr("height", function (d) {
                return chart.height - y1AxisLabel(d.metric1);
            });

        slice.selectAll("text")
            .data(function (d) {
                return d.values;
            })
            .enter().append("text")
            .attr('transform', 'rotate(-90)')
            .attr("x", function (d) {
                return -y1AxisLabel(d.metric1)
            })
            .attr("y", function (d, i) {
                return (i * x2AxisLabel.bandwidth()) + (x2AxisLabel.bandwidth() / 2) + 7;
            })
            .text(function (d) {
                return inrFormatter(Math.round(d.metric1))
            })
            .style('font-size', '20px')

        var y1legend = svg.selectAll(".legend")
            .data(metric1ColorScale.domain())
            .enter().append('g')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 320 * i; // NEW
                var vert = 150;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y1legend.append('rect')
            .attr('x', 10)
            .attr('y', chart.height + chart.margin.bottom - 110)
            .attr('width', 25)
            .attr('height', 25)
            .attr('fill', metric1ColorScale)

        y1legend.append('text')
            .attr('x', 50)
            .attr('y', chart.height + chart.margin.bottom - 110)
            .attr('dy', '0.62em')
            .text(function (d) {
                if (d.length > 10)
                    return d.substring(0, 7)
                else {
                    return d
                }
            })
            .style('font-size', '30px');

    })
}
